export default __webpack_public_path__ + "img/mpc-fleet.5a67db90.png";